import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgRss = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.2 20.667C17.2 13.059 10.94 6.8 3.332 6.8V3.333c9.508 0 17.334 7.826 17.334 17.334h-3.468zM5.71 15.91a2.383 2.383 0 012.378 2.38 2.385 2.385 0 01-2.384 2.376 2.374 2.374 0 01-2.37-2.376 2.381 2.381 0 012.376-2.38zm9.113 4.756h-3.369c0-4.456-3.665-8.122-8.12-8.122V9.176c6.302 0 11.49 5.189 11.49 11.49z"
      clipRule="evenodd"
    />
  </svg>
));
SvgRss.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgRss;
